export default __webpack_public_path__ + "static/front-cover-coast-bdecf89f03854e0601f4316f8695f39f.png";